(() => {
  'use strict';
  if (customElements.get('product-recommendations')) return;
  const cache=new Map();
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.controller || this.dataset.rendered==='true') return;
      this.controller=new AbortController();
      this.addEventListener('click',event=>{if(event.target.closest('[data-recommendations-retry]')){event.preventDefault();this.load();}},{signal:this.controller.signal});
      if('IntersectionObserver' in window){
        this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'400px 0px'});
        this.observer.observe(this);
      }else this.load();
    }
    disconnectedCallback(){this.controller?.abort();this.requestController?.abort();this.observer?.disconnect();this.controller=null;this.loading=false;}
    async load(){
      if(this.loading)return;
      this.loading=true;this.setAttribute('aria-busy','true');
      const error=this.querySelector('[data-recommendations-error]');if(error)error.hidden=true;
      this.requestController?.abort();this.requestController=new AbortController();const signal=this.requestController.signal;
      try{
        const url=new URL(this.dataset.url,location.origin);if(url.origin!==location.origin)throw new Error('Invalid recommendation URL');
        url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('product_id',this.dataset.productId);url.searchParams.set('limit','10');url.searchParams.set('intent','related');
        const theme=window.Shopify?.theme;const previewId=new URL(location.href).searchParams.get('preview_theme_id')||(theme&&['unpublished','development'].includes(theme.role)?theme.id:null);
        if(previewId)url.searchParams.set('preview_theme_id',String(previewId));
        let source=cache.get(url.href);
        if(!source){const response=await fetch(url,{signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error('Recommendations could not be loaded');source=await response.text();}
        if(signal.aborted||!this.isConnected)return;
        const html=new DOMParser().parseFromString(source,'text/html');const replacement=html.querySelector('product-recommendations');
        if(!replacement||replacement.dataset.rendered!=='true')throw new Error('Recommendations section missing');
        if(cache.size>=12)cache.delete(cache.keys().next().value);cache.set(url.href,source);
        this.replaceWith(replacement);window.OleaProductReveal?.(replacement);
      }catch(reason){
        if(reason.name==='AbortError'||signal.aborted)return;
        this.dataset.rendered='error';this.removeAttribute('aria-busy');
        const loading=this.querySelector('[data-recommendations-loading]');if(loading)loading.hidden=true;
        if(error)error.hidden=false;
      }finally{this.loading=false;}
    }
  }
  customElements.define('product-recommendations',ProductRecommendations);
})();
